const selectors = {
  stickyList: '[data-faq-list]',
  faqLinks: '[data-faq-link]',
  faqHeadings: '[data-faq-heading]',
};

const state = {
  activeLink: '--active',
}

function iconicIntersectionObserver() {
  const header = document.getElementById('shopify-section-header');
  const faqHeader = document.querySelector(selectors.stickyList);
  const faqHeadings = [...document.querySelectorAll(selectors.faqHeadings)];
  const faqLinks = document.querySelectorAll(selectors.faqLinks);
  let prevYPosition = window.scrollY;
  let direction = 'up';
  let observerDisabled = false;

  const getTargetSection = (entry) => {
    const index = faqHeadings.findIndex((faqHeading) => faqHeading == entry.target);
     return (index >= faqHeadings.length - 1)
      ? entry.target
      : faqHeadings[index + 1];
  }
  
  const shouldUpdate = (entry) => {
    if (direction === 'down' && !entry.isIntersecting) {
      return true;
    }
  
    if (direction === 'up' && entry.isIntersecting) {
      return true;
    }
    
    return false;
  }

  const updateActiveLink = (activeLink) => {
    faqLinks.forEach((link) => link.classList.remove(state.activeLink));
    activeLink.classList.add(state.activeLink);
  };

  const onIntersect = (entries) => {
    if (observerDisabled) { return true; }
    entries.forEach(entry => {
      if (window.scrollY > prevYPosition) {
        direction = 'down';
      } else {
        direction = 'up';
      }
      prevYPosition = window.scrollY;
      
      const target = direction === 'down' ? getTargetSection(entry) : entry.target;

      if (shouldUpdate(entry)) {
        const activeLink = document.querySelector(`[href="#${entry.target.id}"]`);
        updateActiveLink(activeLink);
      }
    });
  }

  const observer = new IntersectionObserver(onIntersect, {
    rootMargin: `${(header.offsetHeight + (faqHeader.offsetHeight * 2)) * -1}px`,
    threshold: 0,
  });
  faqHeadings.forEach((element) => {
    observer.observe(element);
  });
  faqLinks.forEach(element => {
    element.addEventListener('click', (event) => {
      event.preventDefault();
      const targetedHeading = document.querySelector(event.currentTarget.getAttribute('href'));
      const scrollPosition = targetedHeading.offsetTop + faqHeader.offsetHeight;
      observerDisabled = true;
      window.scrollTo(0, scrollPosition);
      updateActiveLink(event.currentTarget);
      setTimeout(() => {
        observerDisabled = false;
      }, 50);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  iconicIntersectionObserver();
});